import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination} from "../../../shared";
import {TaskContainerModel} from "../../../../../../../models/aggregates/alg/cc/task";
import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class TaskService extends BaseApiTemplateService<TaskContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'tasks';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'tasks';
    this.httpClient = http;
  }

  async exportTaskReportCsvAsBlob(pagination: Pagination, authorization: string, apiVisa: ApiVisa){
    const CSV_URL = this.apiUrl + '/export/csv?' + pagination.getQueryKeyValues();
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode" : apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }

  assignTask(conversationUuid, conversationTitle, userId, targetType, virtualId, channel, assigneeGuid, assigneeTable, apiVisa: ApiVisa){
    let url = apiVisa.api_domain_url + this.endpoint_path + '/assign-task?' + "conversationUuid=" + conversationUuid + "&conversationTitle=" + conversationTitle + 
      "&userId=" + userId + "&targetType=" + targetType + "&virtualId=" + virtualId + "&channel=" + channel + "&assigneeGuid=" + assigneeGuid + "&assigneeTable=" + assigneeTable;
    return this.httpClient.get(url, this.getHttpHeader(apiVisa));
  }
}